<script setup lang="ts">
import type { IFooterCaptionProps } from '@/widgets/LawyerCard/model/types/lawyerCard';
import type { ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

const props = withDefaults(defineProps<IFooterCaptionProps>(), {
  isCatalog: false,
  isSlider: false,
});

const router = useRouter();
const isMobile: boolean = useIsMobile();
const lawyerInfo = inject<ILawyerCardInfo>('lawyerInfo');

const description: ComputedRef<string | undefined> = computed(
  () => lawyerInfo?.description,
);

const goTo = (): void => {
  router.push(props.linkToProfileCatalog);
};
</script>

<template>
  <div
    :class="[
      'footer-caption',
      { _mobile: isMobile },
      { _catalog: isCatalog },
      { _slider: isSlider },
    ]"
  >
    <p class="footer-caption__text">
      {{ description }}
    </p>
    <div class="footer-caption__buttons">
      <AppButton
        class="footer-caption__button"
        is-small
        is-bordered
        is-white
        button-text="В профиль"
        right-icon-name="ArrowRight"
        right-icon-width="12"
        right-icon-height="12"
        @click="goTo"
      />
    </div>
  </div>
</template>

<style lang="less">
.footer-caption {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;

  &__text {
    margin: 0 0 @size-x4 0;
    font-weight: 500;
    font-size: @size-x3;
    line-height: @size-x4;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    max-width: 285px;
    max-height: 45px;
    margin-left: auto;
    gap: @size-x5;
  }

  &._catalog {
    display: flex;
    align-items: center;
  }

  &._catalog &__text {
    .overflow-ellipsis-lines(3);

    margin-right: @size-x10;
    margin-bottom: 0;
  }

  &._catalog &__buttons {
    align-items: flex-end;
  }

  &._slider &__text {
    .overflow-ellipsis-lines(3);

    margin-bottom: @size-x4;
  }

  &._mobile {
    display: block;
  }

  &._mobile &__text {
    font-size: @size-x3;
    line-height: @size-x4;
    margin-bottom: @size-x4;
  }

  &._mobile._catalog &__text {
    margin-right: 0;
    margin-bottom: @size-x4;
  }
}
</style>
